require('./inc/site.js');
require('./inc/core/tooltipster.js');

$(document).ready(function(){
  $('.orders-table .order-row > .col').on('click', function(){
    if (!$(this).hasClass('identity-col')) {
      var row = $(this).parents('.order-row');

      if (row && row.length == 1) {
        var details = row.find('.details-outer');
        if (details && details.length > 0) {
          row.toggleClass('opened');
          row.find('.arrow-link').toggleClass('opened');
          details.slideToggle();
        }
      }
    }
  });

  $('.custom-file-input').on('change', function(){
    var field = $(this)[0];
    var label = $('label[for="'+$(this).attr('id')+'"]').find('.label');
    if (label && label.length > 0) {
      if (field.files.length > 0) {
        label.html(field.files[0].name);
      } else {
        label.html(label.data('empty-label'));
      }
    }
  });

  addAddressDOMEvents();
});


function initTooltipster()
{
  $.fn.tooltipster('setDefaults', {
    position: 'top'
  });

  var trigger = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) ? "click" : "hover";

  $('.tooltip:not(.initialized)').each(function(){
    $(this).addClass('initialized');
    $(this).tooltipster({
      contentAsHTML:true,
      trigger: trigger
    });
  });
}

var openedAddressId = undefined;
if (typeof singleActiveAddress === 'undefined') {
  var singleActiveAddress = false;
}

function addAddressDOMEvents() {
  $('[data-purpose="modify-address"]:not(.initialized)').on('click', function(){
    $(this).addClass('initialized');
    var box = $(this).parents('.address-block');
    var addressId = $(this).data('address-id');
    var timeout = 0;

    if (singleActiveAddress && openedAddressId && addressId != openedAddressId) {
      timeout = 400;
      openedAddressId = undefined;

      $('.form-outer.opened').each(function(){
        $(this).removeClass('opened');
        $(this).slideUp();
      });
    }

    var formContent = box.find('.form-outer');
    if (formContent && formContent.length === 1) {
      setTimeout(function(){
        formContent.toggleClass('opened');
        formContent.slideToggle();

        if (formContent.hasClass('opened')) {
          openedAddressId = addressId;
        }
      }, timeout);
    }
  });

  $('[data-purpose="delete-address"]:not(.initialized)').on('click', function(){
    var btn = $(this);

    var title = typeof window.messageHandlerObj !== 'undefined' ? window.messageHandlerObj.getText('deleteAddressTitle') : 'Cím törlése';
    var text = typeof window.messageHandlerObj !== 'undefined' ? window.messageHandlerObj.getText('deleteAddressLead') : 'Biztos, hogy törli ezt a címet?';
    var confirm = typeof window.messageHandlerObj !== 'undefined' ? window.messageHandlerObj.getText('confirmText') : 'Igen';
    var cancel = typeof window.messageHandlerObj !== 'undefined' ? window.messageHandlerObj.getText('cancelText') : 'Mégse';

    Swal.fire({
      type:'warning',
      showCancelButton: true,
      buttonsStyling: false,
      confirmButtonText: confirm,
      cancelButtonText: cancel,
      title: title,
      text: text
    }).then(function(result){
      if (typeof result.value === 'boolean' && result.value) {
        $(document).trigger(PROJECT_NAMESPACE+'.delete_address', {
          button: btn
        });

        btn.off('click');
        btn.parents('.address-block').slideUp(400, function(){
          $(this).remove();
        });
      }
    });


    $(this).addClass('initialized');
  });

  initTooltipster();
}

window.initTooltipster = initTooltipster;
window.addAddressDOMEvents = addAddressDOMEvents;

